<template>
    <div>
        <template v-if="view_attendance_correction === true && data !== null">
            <div class="clearfix">
                <div class="page-top mb-1 mb-3 align-center clearfix">
                    <h1 class="float-left"> Attendance Correction </h1>
                </div>
                <div class="global-main">
                    <div class="attandance-correction">
                        <div class="attancance-correction-head mb-3 clearfix">
                            <div class="image-holder">
                                <img :src="data.user.picture" alt="" />
                            </div>
                            <div class="title-holder">
                                <h2> {{data.user.name}} </h2>
                                <span class="attandance-status"> {{data.user.current_status}} </span>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-sm-3">
                                <span class="title"> Date </span>
                                <p> {{data.user.attendance_time}} </p>
                            </div>
                            <div class="col-sm-3">
                                <span class="title"> Type </span>
                                <p> {{data.user.attendance_type}} </p>
                            </div>
                            <div class="col-sm-3">
                                <span class="title"> Time in </span>
                                <p> {{data.user.time_in}} </p>
                            </div>
                            <div class="col-sm-3">
                                <span class="title"> Time out </span>
                                <p> {{data.user.time_out}} </p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12">
                                <span class="title"> Message </span>
                                <p> {{data.user.message}}</p>
                            </div>
                        </div>
                        <h3 class="mt-3 mb-4"> History </h3>
                    </div>
                </div>
            </div>
        </template>
        <template v-else-if="view_attendance_correction === null && data === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="view_attendance_correction === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>
<script>
// Main JS (in UMD format)
import VueTimepicker from 'vue2-timepicker';
// CSS
import 'vue2-timepicker/dist/VueTimepicker.css';
    export default {
        components: {
            VueTimepicker
        },
        data() {
            return {
                id: this.$route.params.id,
                data: null,
                view_attendance_correction: null,
                flag: false,
                form : new Form({
                    approvalType: null,
                    attendanceCorrectionId: this.$route.params.id,
                    message: null,
                    timeIn: '',
                    timeOut: ''
                })
            };
        },
        created (){
        },
        mounted() {
            this.viewAttendacneCorrection();
            this.$global.getName();
        },
        methods: {
            viewAttendacneCorrection(){
                let that = this;
                that.$Progress.start();
                axios.get('/api/viewAttendanceCorrection/'+that.$route.params.id)
                .then(res => {
                    that.data = res.data;
                    if(res.data){
                        this.form.timeIn = that.data.user.time_in;
                        this.form.timeOut = that.data.user.time_out;
                        that.view_attendance_correction = res.data.view_attendance_correction;
                        if(res.data.flag == true){
                            that.flag = true;
                        }else{
                            that.flag = false;
                        }
                    }else{
                        that.view_attendance_correction = false;
                        that.flag = false;
                    }
                    that.$Progress.finish();
                }).catch(err => {
                    console.log(err);
                });
            }
        },
    }
</script>
